import "./LandingLogos.css";

const LOGOS = ["1", "2", "3"];

function LandingLogos() {
  const looped = [...LOGOS, ...LOGOS];

  return (
    <section className="landing-logos">
      <p className="landing-logos__label">Onze klanten</p>
      <div className="landing-logos__viewport" aria-hidden="true">
        <div className="landing-logos__track">
          {looped.map((id, index) => (
            <div className="landing-logos__item" key={`${id}-${index}`}>
              <img
                src={`/klant-logo-${id}.png`}
                alt={`Klant logo ${id}`}
                className="landing-logos__logo"
              />
            </div>
          ))}
        </div>
        <div className="landing-logos__fade landing-logos__fade--left"></div>
        <div className="landing-logos__fade landing-logos__fade--right"></div>
      </div>
    </section>
  );
}

export default LandingLogos;
